import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { AppState } from "../root";
import { AuditService } from "../../services/audit/audit.service";
import { AuditActions } from "./audit.actions";
import { switchMap, of, withLatestFrom } from "rxjs";
import { selectUser } from "../user/user.selectors";
import { AuditRequest } from "../../models/audit.model";


@Injectable()
export class AuditEffects {
    private actions$ = inject(Actions);
    private store$ = inject(Store<AppState>);
    private auditService = inject(AuditService);

    addAuditEntry$ = createEffect(() => this.actions$.pipe(
        ofType(AuditActions.addAuditEntry),
        withLatestFrom(this.store$.select(selectUser)),
        switchMap(([action, user]) => {
            if (user == null) {
                return of(AuditActions.addAuditEntryFailure({ error: Error("Invalid user") }))
            }

            const auditRequest = { ...action.auditRequest } as AuditRequest;
            auditRequest.message = `${user.username} ${auditRequest.message}`;
            auditRequest.organisation_id = user.organisation_id;
            auditRequest.user_id = user.id;

            return this.auditService.addAuditEntry(auditRequest);
        })
    ), { dispatch: false })
}
